import type { App } from 'vue';
import type { ArcoOptions } from '../_utils/types';
import { setGlobalConfig, getComponentPrefix } from '../_utils/global-config';
import _AddPositionCollaborator from './add-position-collaborator.vue';

const AddPositionCollaborator = Object.assign(_AddPositionCollaborator, {
  install: (app: App, options?: ArcoOptions) => {
    setGlobalConfig(app, options);
    const componentPrefix = getComponentPrefix(options);

    app.component(
      componentPrefix + _AddPositionCollaborator.name,
      _AddPositionCollaborator
    );
  },
});

export type AddPositionCollaboratorInstance = InstanceType<
  typeof _AddPositionCollaborator
>;

export default AddPositionCollaborator;
